import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react'

const config = {
  apiKey: '5d1a246c',
  environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV,
  revision: process.env.REACT_APP_COMMIT_HASH
}

const honeybadger = Honeybadger.configure(config)

Honeybadger.beforeNotify((notice) => {
  // https://docs.honeybadger.io/lib/javascript/guides/reducing-noise/
  if (notice.name === "RangeError") {
    return false
  }

  // Seems to affect iOS 14, but haven't heard any customer complaints.
  if (notice.message === "Origin https://device.dreception.com is not allowed by Access-Control-Allow-Origin.") {
    return false
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const app = (
  <HoneybadgerErrorBoundary honeybadger={honeybadger}>
    <App />
  </HoneybadgerErrorBoundary>
)

root.render(
  process.env.REACT_APP_DISABLE_STRICT_MODE === "true" ? app : <React.StrictMode>{app}</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
